<mat-card class="costOutage-counties-calculated-widget-container">
  <div #exportContent>
    <div class="header">
      <div class="title">Residential and Non-Residential Cost of Outage Per Year</div>
      <button class="header-btn" mat-icon-button data-html2canvas-ignore (click)="export()">
        <vulcan-icon size="24px" icon="download"></vulcan-icon>
      </button>
    </div>
    <div class="content">
      <ul>
        <li>Measures what a customer would pay for backup service to avoid service interruptions.</li>
        <li>Captures both tangible & intangible losses (e.g., inconvenience) in willingness-to-pay schema.</li>
      </ul>
    </div>

  </div>
</mat-card>

